/**
 * Environment configuration for Vite
 * Access via import.meta.env.VITE_* in the code
 * 
 * For Clerk:
 * VITE_CLERK_PUBLISHABLE_KEY (fallback: NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY)
 * 
 * For Chipi:
 * VITE_CHIPI_API_KEY (fallback: NEXT_PUBLIC_CHIPI_API_KEY)
 * 
 * For Supabase:
 * VITE_SUPABASE_URL (fallback: NEXT_PUBLIC_SUPABASE_URL)
 * VITE_SUPABASE_ANON_KEY (fallback: NEXT_PUBLIC_SUPABASE_ANON_KEY)
 */

function getEnv(key: string, fallback?: string): string {
  const value = (import.meta as any).env?.[`VITE_${key}`] || (import.meta as any).env?.[`NEXT_PUBLIC_${key}`] || fallback
  return value || ''
}

export const envConfig = {
  // Clerk Configuration
  clerk: {
    publishableKey: getEnv('CLERK_PUBLISHABLE_KEY'),
    signInUrl: getEnv('CLERK_SIGN_IN_URL', '/auth'),
    signUpUrl: getEnv('CLERK_SIGN_UP_URL', '/auth'),
    afterSignInUrl: getEnv('CLERK_AFTER_SIGN_IN_URL', '/dashboard'),
    afterSignUpUrl: getEnv('CLERK_AFTER_SIGN_UP_URL', '/dashboard'),
  },
  
  // Chipi Configuration
  chipi: {
    apiPublicKey: getEnv('CHIPI_API_KEY'),
    alphaUrl: getEnv('CHIPI_ALPHA_URL', 'https://alpha.chipi.io'),
  },
  
  // Supabase Configuration
  supabase: {
    url: getEnv('SUPABASE_URL'),
    anonKey: getEnv('SUPABASE_ANON_KEY'),
  },
}
